const editorialFeedRequests = new Map();

function requestEditorialFeed(url) {
  if (!editorialFeedRequests.has(url)) {
    editorialFeedRequests.set(url, fetch(url, {
      headers: { accept: 'application/json' },
      credentials: 'omit',
      mode: 'cors',
    }).then((response) => {
      if (!response.ok) throw new Error(`Editorial feed returned ${response.status}`);
      return response.json();
    }));
  }
  return editorialFeedRequests.get(url);
}

class PtflHomeEditorial extends HTMLElement {
  connectedCallback() {
    this.load().catch(() => this.showUnavailable());
  }

  async load() {
    const source = this.dataset.source;
    if (!source) throw new Error('Editorial feed is not configured');
    const feed = await requestEditorialFeed(source);
    if (this.dataset.kind === 'camera_reviews') {
      this.renderCameraReviews(Array.isArray(feed.camera_reviews) ? feed.camera_reviews : []);
      return;
    }
    this.renderGallery(Array.isArray(feed.gallery) ? feed.gallery : []);
  }

  renderGallery(stories) {
    const track = this.querySelector('[data-editorial-items]');
    if (!track) return;
    track.replaceChildren(...stories.map((story, index) => galleryLink(story, index)));
    this.classList.remove('is-loading');
    this.classList.add('is-ready');
    const status = this.querySelector('[data-editorial-status]');
    if (status) status.textContent = stories.length ? '' : 'No Gallery stories are currently available.';
  }

  renderCameraReviews(reviews) {
    if (!reviews.length) return;
    const grid = this.querySelector('[data-editorial-items]');
    if (!grid) return;
    grid.replaceChildren(...reviews.map((review) => reviewCard(review)));
    this.classList.remove('is-loading');
    this.classList.add('is-ready');
    const section = this.closest('[data-editorial-section]');
    if (section) section.hidden = false;
  }

  showUnavailable() {
    if (this.dataset.kind === 'camera_reviews') return;
    this.classList.remove('is-loading');
    const status = this.querySelector('[data-editorial-status]');
    if (status) status.textContent = 'The Gallery preview is temporarily unavailable.';
  }
}

function galleryLink(story, index) {
  const link = document.createElement('a');
  link.className = 'ptfl-gallery-strip__item';
  link.href = safeUrl(story.url);
  link.setAttribute('aria-label', `Open Gallery story: ${plainText(story.title)}`);
  link.append(responsivePicture(story.image, gallerySizes(), index === 0));
  return link;
}

function reviewCard(review) {
  const article = document.createElement('article');
  article.className = 'ptfl-camera-preview__card';
  const link = document.createElement('a');
  link.href = safeUrl(review.url);
  link.className = 'ptfl-camera-preview__link';
  link.append(responsivePicture(review.image, '(max-width: 760px) 86vw, 31vw', false));

  const copy = document.createElement('div');
  copy.className = 'ptfl-camera-preview__copy';
  const label = document.createElement('p');
  label.className = 'ptfl-label';
  label.textContent = plainText(review.camera_name) || 'Camera Review';
  const heading = document.createElement('h3');
  heading.textContent = plainText(review.title);
  const contributor = document.createElement('p');
  contributor.textContent = `Reviewed by ${plainText(review.contributor)}`;
  copy.append(label, heading, contributor);
  link.append(copy);
  article.append(link);
  return article;
}

function responsivePicture(image, sizes, eager) {
  const width = positiveNumber(image?.width, 1200);
  const height = positiveNumber(image?.height, 800);
  const picture = document.createElement('picture');
  picture.style.setProperty('--ptfl-image-ratio', `${width} / ${height}`);
  const source = document.createElement('source');
  source.type = 'image/webp';
  source.srcset = plainText(image?.webp_srcset);
  source.sizes = sizes;
  const photograph = document.createElement('img');
  photograph.src = safeUrl(image?.src);
  photograph.srcset = plainText(image?.jpeg_srcset);
  photograph.sizes = sizes;
  photograph.width = width;
  photograph.height = height;
  photograph.alt = plainText(image?.alt);
  photograph.loading = eager ? 'eager' : 'lazy';
  photograph.decoding = 'async';
  if (eager) photograph.fetchPriority = 'high';
  picture.append(source, photograph);
  return picture;
}

function gallerySizes() {
  return '(max-width: 620px) 86vw, (max-width: 1200px) 30vw, 24vw';
}

function safeUrl(value) {
  const text = plainText(value);
  return /^https:\/\/gallery\.picturethisfilmlab\.com\//u.test(text) ? text : '#';
}

function plainText(value) {
  return typeof value === 'string' ? value : '';
}

function positiveNumber(value, fallback) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? Math.round(number) : fallback;
}

if (!customElements.get('ptfl-home-editorial')) {
  customElements.define('ptfl-home-editorial', PtflHomeEditorial);
}
